import { render, staticRenderFns } from "./UiRadio.vue?vue&type=template&id=3f02d957&scoped=true&"
import script from "./UiRadio.vue?vue&type=script&lang=js&"
export * from "./UiRadio.vue?vue&type=script&lang=js&"
import style0 from "./UiRadio.vue?vue&type=style&index=0&id=3f02d957&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02d957",
  null
  
)

export default component.exports